var _g, _text, _text2, _ellipse, _ellipse2, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 409,
    height: 360,
    viewBox: "0 0 409 360",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-448 -239)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -8)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(555 343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.5,41.971h-.878c18.2-.059,35.281-2.045,48.092-5.593,6.238-1.728,11.133-3.734,14.549-5.964,3.537-2.309,5.331-4.76,5.331-7.286,0-2.544-1.819-5.012-5.407-7.335-3.465-2.244-8.426-4.259-14.745-5.99-13-3.559-30.273-5.519-48.652-5.519S39.13,6.243,26.135,9.8c-6.319,1.731-11.28,3.746-14.745,5.99C7.8,18.115,5.983,20.583,5.983,23.127c0,3.6,3.712,7.093,10.733,10.111,6.836,2.939,16.478,5.3,27.884,6.827C31.477,38.412,20.353,35.78,12.43,32.457,4.3,29.046,0,25.079,0,20.985a7.056,7.056,0,0,1,1.554-4.229,17.153,17.153,0,0,1,4.457-3.939,42.389,42.389,0,0,1,7.053-3.565,84.4,84.4,0,0,1,9.341-3.106,164.754,164.754,0,0,1,24.315-4.5A259.634,259.634,0,0,1,76.5,0a259.634,259.634,0,0,1,29.776,1.649,164.753,164.753,0,0,1,24.315,4.5,84.4,84.4,0,0,1,9.341,3.106,42.39,42.39,0,0,1,7.053,3.565,17.154,17.154,0,0,1,4.457,3.939,7.056,7.056,0,0,1,1.554,4.229,7.056,7.056,0,0,1-1.554,4.229,17.154,17.154,0,0,1-4.457,3.939,42.389,42.389,0,0,1-7.053,3.565,84.4,84.4,0,0,1-9.341,3.106,164.75,164.75,0,0,1-24.315,4.5A259.631,259.631,0,0,1,76.5,41.971Z",
    transform: "translate(23.06 25.724)",
    fill: "#bfcbdb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.584,8.636a1.876,1.876,0,0,1,3.2,1.85h0a1.876,1.876,0,0,0,1.447,2.507h0a1.876,1.876,0,0,1,0,3.7h0A1.876,1.876,0,0,0,21.789,19.2h0a1.876,1.876,0,0,1-3.2,1.85h0a1.876,1.876,0,0,0-2.895,0h0a1.876,1.876,0,0,1-3.2-1.85h0a1.876,1.876,0,0,0-1.447-2.507h0a1.876,1.876,0,0,1,0-3.7h0a1.876,1.876,0,0,0,1.447-2.507h0a1.876,1.876,0,0,1,3.2-1.85h0a1.876,1.876,0,0,0,2.895,0Z",
    transform: "translate(68.757 0) rotate(30)",
    fill: "#00f2fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.408,5.263A1.147,1.147,0,0,1,13.365,6.4l0,.01a1.147,1.147,0,0,0,.885,1.534h0a1.147,1.147,0,0,1,0,2.262h0a1.147,1.147,0,0,0-.885,1.534l0,.01a1.147,1.147,0,0,1-1.957,1.134l-.016-.019a1.147,1.147,0,0,0-1.767,0l-.016.019a1.147,1.147,0,0,1-1.957-1.134l0-.01A1.147,1.147,0,0,0,6.77,10.2h0a1.147,1.147,0,0,1,0-2.262h0a1.147,1.147,0,0,0,.885-1.534l0-.01A1.147,1.147,0,0,1,9.609,5.263l.016.019a1.147,1.147,0,0,0,1.767,0Z",
    transform: "matrix(0.588, 0.809, -0.809, 0.588, 182.518, 27.666)",
    fill: "#00f2fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.61,6.278a1.368,1.368,0,0,1,2.335,1.352l0,.012A1.368,1.368,0,0,0,17,9.472h0a1.368,1.368,0,0,1,0,2.7h0A1.368,1.368,0,0,0,15.941,14l0,.012a1.368,1.368,0,0,1-2.335,1.352l-.019-.023a1.368,1.368,0,0,0-2.108,0l-.019.023a1.368,1.368,0,0,1-2.335-1.352l0-.012a1.368,1.368,0,0,0-1.056-1.83h0a1.368,1.368,0,0,1,0-2.7h0a1.368,1.368,0,0,0,1.056-1.83l0-.012a1.368,1.368,0,0,1,2.335-1.352l.019.023a1.368,1.368,0,0,0,2.108,0Z",
    transform: "translate(0 42.7) rotate(-2)",
    fill: "#00f2fe"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(502 552)",
    fill: "#00f2fe",
    fontSize: 157,
    fontFamily: "Poppins-Bold, Poppins",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -53.145,
    y: 0
  }, "4"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(803 552)",
    fill: "#00f2fe",
    fontSize: 157,
    fontFamily: "Poppins-Bold, Poppins",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -53.145,
    y: 0
  }, "4"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.789,
    cy: 95.789,
    rx: 95.789,
    ry: 95.789,
    transform: "translate(558.843 391.249)",
    fill: "#00f2fe"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.697,
    cy: 81.573,
    rx: 89.697,
    ry: 81.573,
    transform: "translate(565 391.249)",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.25,
    cy: 20.674,
    rx: 41.25,
    ry: 20.674,
    transform: "translate(614 397.249)",
    fill: "#fff",
    opacity: 0.71
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(612.894 457.872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6839.662,301.111l20.813,7.936v8.086s.9,11.05-10.032,11.68-10.781-10.482-10.781-10.482Z",
    transform: "translate(-6791.48 -248.382)",
    fill: "#ea4941"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.254-16.512a4,4,0,0,1-3.442-1.956c-.322-.523-8.472-13.372-30.7-13.372-22.65,0-32.091,13.447-32.184,13.583a4,4,0,0,1-5.559,1.048,4,4,0,0,1-1.048-5.559c.476-.7,11.963-17.073,38.791-17.073,26.989,0,37.158,16.577,37.578,17.283a4,4,0,0,1-1.393,5.483A3.982,3.982,0,0,1,74.254-16.512Z",
    transform: "translate(2.351 87.521)",
    fill: "#323141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.825-8.92a4,4,0,0,1-3.476-2.016c-.259-.429-7.133-11.417-29.23-11.417-22.375,0-30.253,9.616-30.33,9.713a4.022,4.022,0,0,1-5.6.7,3.978,3.978,0,0,1-.769-5.55c.395-.525,9.98-12.866,36.694-12.866,27.035,0,35.815,14.816,36.175,15.446a4,4,0,0,1-1.488,5.458A3.982,3.982,0,0,1,70.825-8.92Z",
    transform: "translate(2.351 82.09)",
    fill: "#323141",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.965,23.965a3.988,3.988,0,0,1-2.828-1.172L-2.828,2.828a4,4,0,0,1,0-5.657,4,4,0,0,1,5.657,0L22.793,17.136a4,4,0,0,1-2.828,6.828Z",
    fill: "#323141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,23.965a3.988,3.988,0,0,1-2.828-1.172,4,4,0,0,1,0-5.657L17.136-2.828a4,4,0,0,1,5.657,0,4,4,0,0,1,0,5.657L2.828,22.793A3.988,3.988,0,0,1,0,23.965Z",
    fill: "#323141"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.722 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.965,23.965a3.988,3.988,0,0,1-2.828-1.172L-2.828,2.828a4,4,0,0,1,0-5.657,4,4,0,0,1,5.657,0L22.793,17.136a4,4,0,0,1-2.828,6.828Z",
    transform: "translate(0)",
    fill: "#323141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,23.965a3.988,3.988,0,0,1-2.828-1.172,4,4,0,0,1,0-5.657L17.136-2.828a4,4,0,0,1,5.657,0,4,4,0,0,1,0,5.657L2.828,22.793A3.988,3.988,0,0,1,0,23.965Z",
    transform: "translate(0)",
    fill: "#323141"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(41 10.668)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 188,
    height: 74,
    rx: 37,
    transform: "translate(520 228.332)",
    fill: "#010326"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(613 279.332)",
    fill: "aqua",
    fontSize: 36,
    fontFamily: "Poppins-Bold, Poppins",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -57.654,
    y: 0
  }, "OOPS!")), /*#__PURE__*/React.createElement("path", {
    d: "M21,0,42,36H0Z",
    transform: "translate(635 338.332) rotate(180)",
    fill: "#010326"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg404);
export default __webpack_public_path__ + "static/media/img-404.c62058baf26e0b7cfb71fb43fed9234c.svg";
export { ForwardRef as ReactComponent };